import React, { useContext, useEffect, useState } from 'react'
import { get } from '../../lib/api'
import GenericError from '../GenericError'
import {
  checkOverseasUser,
  getParticularDocument,
  getTokenAndUid,
} from '../../lib/utils'
import Loader from '../Loader'
import { AccountContext } from '../../providers/accountProvider'

const ProfileContainer = (props) => {
  const [userData, setUserData] = useState({})
  const [apiError, toggleApiError] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const { user } = useContext(AccountContext)
  const isOverseasUser = checkOverseasUser(user)
  useEffect(() => {
    fetchData()
  }, [user])

  const fetchData = async function () {
    setIsLoading(true)
    const { uid } = getTokenAndUid()
    const allPromises = [
      // get('/user_api/user.get_details', {
      //   params: {
      //     uid,
      //     is_novel: 1,
      //   },
      // }),
      get('/user_api/user.get_creator_details?is_novel=1'),
      get(`/user_api/user_addresses/${uid}/?is_novel=1`),
      !isOverseasUser
        ? get(`/user_api/user_bank_accounts/${uid}/?is_novel=1`)
        : get(`/user_api/row_creator/${uid}/?is_novel=1`),
    ]
    Promise.all(allPromises)
      .then((responseArray) => {
        const [
          // userDetails,
          creatorAccDetails,
          addressDetails,
          bankDetails,
        ] = responseArray
        // These details should be from creators table
        // const { fullname, gender, email, phone_number, bio, image_url } =
        //   userDetails.result[0]
        const {
          fullname,
          gender,
          email,
          phone_number,
          bio,
          image_url,
          account_type,
          languages,
          invite_code,
        } = creatorAccDetails.result
        console.log('creatorAccDetails.result', creatorAccDetails.result)
        console.log('invite_code', invite_code)
        const { address_id, address_1, address_2, pin_code, city, state } =
          addressDetails.result[0] || {}
        setIsLoading(true)
        let authorBankDetails = {}
        if (isOverseasUser) {
          if (bankDetails.documents) {
            var cancelled_cheque_url = getParticularDocument(
              bankDetails.documents,
              'cancelled_cheque_url',
              'url'
            )
            var f10 = getParticularDocument(bankDetails.documents, 'f10', 'url')
            var npec = getParticularDocument(
              bankDetails.documents,
              'npec',
              'url'
            )
            var trc = getParticularDocument(bankDetails.documents, 'trc', 'url')
            var govt_id_url = getParticularDocument(
              bankDetails.documents,
              'govt_id_url',
              'url'
            )
            var w9 = getParticularDocument(bankDetails.documents, 'w9', 'url')
            var w8 = getParticularDocument(bankDetails.documents, 'w8', 'url')
            var ssn_or_ein_url = getParticularDocument(
              bankDetails.documents,
              'ssn_or_ein_url',
              'url'
            )
            var tax_id_url = getParticularDocument(
              bankDetails.documents,
              'tax_id_url',
              'url'
            )
            var pan_card_url = getParticularDocument(
              bankDetails.documents,
              'pan_card_url',
              'url'
            )
          }
          setIsLoading(true)
          var {
            account_name,
            bank_name,
            account_no,
            swift_code,
            paypal_id,
            gov_id_no,
            id,
          } = bankDetails || {}
        } else {
          let index = bankDetails?.result?.findIndex(
            (data) => data?.is_guardian_account === 1
          )
          const guardianBankResults =
            index !== -1 ? bankDetails?.result[index] : bankDetails?.result[0]
          var {
            account_id,
            account_name,
            bank_name,
            account_no,
            ifsc_code,
            pan_card_no,
            pan_card_url,
            cancelled_cheque_url,
            is_guardian_account,
            guardian_email,
            guardian_phone_number,
          } = guardianBankResults || {}
          index = bankDetails?.result?.findIndex(
            (data) => !data?.is_guardian_account
          )
          authorBankDetails = index !== -1 && bankDetails?.result[index]
          var { aadhaar_card_no, aadhaar_card_url } = authorBankDetails || {}
        }
        setUserData({
          fullname,
          gender,
          email,
          phone_number,
          bio,
          image_url,
          account_type,
          languages,
          address_id,
          address_1,
          address_2,
          pin_code,
          city,
          state,
          account_id,
          account_name,
          bank_name,
          account_no,
          ifsc_code,
          pan_card_no,
          cancelled_cheque_url,
          pan_card_url,
          swift_code,
          f10,
          trc,
          npec,
          govt_id_url,
          w9,
          w8,
          ssn_or_ein_url,
          tax_id_url,
          id,
          gov_id_no,
          paypal_id,
          bankDetailDocuments: bankDetails.documents || [],
          is_guardian_account,
          guardian_email,
          guardian_phone_number,
          aadhaar_card_no,
          aadhaar_card_url,
          authorBankDetails: authorBankDetails || {},
          invite_code: invite_code ? invite_code.invite_code : '',
          show_invite_code: invite_code ? invite_code.show_invite_code : false,
        })
        setIsLoading(false)
      })
      .catch((error) => {
        setIsLoading(false)
        throw error
      })
  }

  const child = React.Children.only(props.children)

  if (isLoading) {
    return <Loader />
  }

  if (apiError) {
    return (
      <GenericError show={apiError} onClose={() => toggleApiError(false)} />
    )
  }
  return React.cloneElement(child, {
    ...props,
    userData,
    isOverseasUser: isOverseasUser,
    reset: fetchData,
  })
}

export default ProfileContainer
